export default __webpack_public_path__ + "static/media/img_404.61808f0b.svg";